import React, { Suspense } from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { RouterView } from './routers/routers';

function App() {
  return (
    <BrowserRouter>
      <Suspense>
        <RouterView />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
